import React, {h, Component} from 'preact';
import constants from "../constants";
import MOTextStyleEdit from "./svg/MOTextStyleEdit";
import {
    AlignLeftOutlined,
    AlignCenterOutlined,
    AlignRightOutlined,
} from "@ant-design/icons";

export default class MOTextAlignWidget extends Component {
    constructor(props) {
        super();

        this.changeAlignment = this.changeAlignment.bind(this);
    }

    changeAlignment(e, alignment) {
        e.stopPropagation();
        if (this.props.priceNum !== null && this.props.priceNum !== undefined) {
            this.props.onStyleChange('align-items', alignment === 'left' ? 'flex-start !important' : alignment === 'right' ? 'flex-end !important' : alignment, this.props.priceNum);
        } else {
            this.props.onStyleChange('text-align', alignment);
        }
    }

    render(props, state) {
        const styles = {
            ...(props.menuObjectStyles[props.type] || {})
        };

        let alignment = 'left';
        if (styles['text-align'] === 'center') {
            alignment = 'center';
        } else if (styles['text-align'] === 'right') {
            alignment = 'right';
        }
        if (props.type.includes('price-entry')) {
            alignment = 'center';

            if (styles['align-items'] === 'flex-start !important') {
                alignment = 'left';
            } else if (styles['align-items'] === 'flex-end !important') {
                alignment = 'right';
            }
        }

        return (
            <div className="dropdown">
                <a className="dropdown-toggle car sm">
                    {alignment === 'left' && <AlignLeftOutlined/>}
                    {alignment === 'center' && <AlignCenterOutlined/>}
                    {alignment === 'right' && <AlignRightOutlined/>}
                </a>
                <div className="dropdown-menu left saf-stop">
                    <div className="text-style-options">
                        <a className={"icn tgl " + (alignment === 'left' ? 'act' : '')} onClick={(ev) => this.changeAlignment(ev, 'left')}>
                            <AlignLeftOutlined/>
                        </a>
                        <a className={"icn tgl " + (alignment === 'center' ? 'act' : '')} onClick={(ev) => this.changeAlignment(ev, 'center')}>
                            <AlignCenterOutlined/>
                        </a>
                        <a className={"icn tgl " + (alignment === 'right' ? 'act' : '')} onClick={(ev) => this.changeAlignment(ev, 'right')}>
                            <AlignRightOutlined/>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}
